var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 123 123",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.01,73.51c3.8,16.46,15.19,24.68,15.19,32.91c0,8.23-3.8,16.46-15.19,16.46 c-11.39,0-15.19-8.23-15.19-16.46C77.82,98.19,89.22,89.97,93.01,73.51L93.01,73.51z M11.63,5.91l5.32-5.32c0.8-0.8,2.1-0.8,2.9,0 l16.19,16.19l8.33-8.33c2.25-2.25,5.94-2.25,8.19,0l42.68,42.68c2.25,2.25,2.25,5.94,0,8.19l-42.68,42.68 c-2.25,2.25-5.94,2.25-8.19,0L1.69,59.33c-2.25-2.25-2.25-5.94,0-8.19l26.13-26.14L11.63,8.81C10.83,8.02,10.83,6.71,11.63,5.91 L11.63,5.91z M51.38,22.02l30.31,30.31c0.89,0.89,1.28,2.09,1.19,3.26H14.06c-0.1-1.17,0.3-2.37,1.18-3.26l30.31-30.31 C47.16,20.42,49.78,20.42,51.38,22.02L51.38,22.02z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorFill);
export default __webpack_public_path__ + "static/media/color-fill.71ba2057a8ab432f24fc8e30d90c18b2.svg";
export { ForwardRef as ReactComponent };